import {isNumber} from "lodash";

export const formatMoney = ({amount, currency = "₺"}) => {
    return `${
        isNumber(amount)
            ? amount?.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
              })
            : "-"
    }  ${currency}`;
};

export const formatMoney2 = ({amount, currency = "₺"}) => {
    if (!amount && amount !== 0 && amount !== "0") return "-";

    const convertedAmount =
        typeof amount === "string" ? parseFloat(amount).toFixed(2) : parseFloat(amount);

    return `${convertedAmount?.toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) || "-"}  ${currency}`;
};

// Türkçe sayı formatlaması için yardımcı fonksiyonlar
export const formatTurkishNumber = value => {
    if (!value) return "";

    let numStr = value.toString().replace(/[^\d,]/g, "");

    const commaCount = (numStr.match(/,/g) || []).length;
    if (commaCount > 1) {
        const firstCommaIndex = numStr.indexOf(",");
        numStr =
            numStr.substring(0, firstCommaIndex + 1) +
            numStr.substring(firstCommaIndex + 1).replace(/,/g, "");
    }

    if (numStr.includes(",")) {
        const parts = numStr.split(",");
        if (parts[1] && parts[1].length > 2) {
            parts[1] = parts[1].substring(0, 2);
        }
        numStr = parts[0] + "," + (parts[1] || "");
    }

    const parts = numStr.split(",");
    const integerPart = parts[0];
    const decimalPart = parts[1];

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return decimalPart !== undefined ? `${formattedInteger},${decimalPart}` : formattedInteger;
};

export const parseTurkishNumber = value => {
    if (!value) return 0;

    const cleanValue = value.replace(/\./g, "").replace(",", ".");

    return parseFloat(cleanValue) || 0;
};
